export const PAID_SERVICE = {
  PACKAGE: 'package',
  BEST_RATE: 'bestRate',
  DISCOUNT: 'discount',
  PROMO_CODE: 'promoCode',
  FEES: 'fees',
  ROOM: 'room',
  ALL_INCLUSIVE: 'allInclusive',
  CHILDCARES: 'childcares',
  TRANSFER: 'transfer',
  TRANSPORT: 'transport',
  SKIPASS: 'skipass',
  BREAKFAST: 'breakfast',
  FFB: 'ffb',
  INSURANCE: 'insurance',
  RENTAL: 'rental',
  EXCURSIONS: 'excursions',
  WELLNESS: 'wellness',
  SPORTS: 'sports',
  DONATION: 'donation',
  TOTAL_PRICE: 'totalPrice',
  DEPOSIT: 'deposit',
} as const;
